











































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import ModalHeader from "@/components/ModalHeader.vue";

@Component({
  components: {
    ModalHeader
  },
  computed: mapState("gaps", ["status"])
})
export default class GapPriority extends Vue {
  @Prop(Array) readonly items!: Array<any>;
  statusId: string | null = null;
  async save() {
    if (!this.statusId) return;
    this.$store.commit("main/SET_LOADING", true);
    try {
      const gapList = this.items.map(item => item.id).join();
      const { statusId } = this;
      await this.$store.dispatch("gaps/saveStatus", {
        gapList,
        statusId
      });
      this.$emit("status-saved");
      this.$modal.hide("gap-status");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
}
